/**
 * 	扫码退券
 */
export default [
  {
    path: '/retreatCoupon',
    component: () => import('@/views/retreatCoupon/Index.vue'),
    meta: { requiresAuth: true, title: '扫码退券', icon: '', role: true },
    children:
      [
        {
          path: '',
          component: () => import('@/views/retreatCoupon/searchType.vue'),
          meta: { title: '扫码退券', role: true },
        },
        {
          path: 'couponSearch',
          component: () => import('@/views/retreatCoupon/couponSearch.vue'),
          meta: { title: '扫码退券', role: true },
        },
        {
          path: 'mobileSearch',
          component: () => import('@/views/retreatCoupon/mobileSearch.vue'),
          meta: { title: '扫码退券', role: true },
        },
        {
          path: 'couponList',
          component: () => import('@/views/retreatCoupon/couponList.vue'),
          meta: { title: '退券列表', role: true },
        },
        {
          path: 'sureRetreat',
          component: () => import('@/views/retreatCoupon/sureRetreat.vue'),
          meta: { title: '扫码退券', role: true },
        },
        {
          path: 'success',
          component: () => import('@/views/retreatCoupon/retreatSuccess.vue'),
          meta: { title: '扫码退券完成', role: true },
        },
      ],
  },
];